import React from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-react/views/dashboardStyle.js';
import Circular from 'components/Circular/Circular';
// core components
import Button from 'components/CustomButtons/Button.js';
import Table from 'components/Table/Table.js';
import SearchForm from 'components/Search/SearchOperations';
import Search from '@material-ui/icons/Search';
import { api } from 'services/api';

import { addHours, format } from 'date-fns'
class LockersOperations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showButtonSearch: true,
      showForm: false,
      lockerAPI: [],
      finalResultAPI: [],
      operations: null,
      code: null,
      circular: true,
      codeAndOperation: null,
    };
  }

  componentDidMount() {
    const urlTest = `/lockers/${this.props.lockerId}/events`;

    api.get(urlTest).then((res) =>
      this.setState({
        lockerAPI: res.data.data
          .filter((res) => res.code > 50)
          .sort((a, b) => b.date.localeCompare(a.date)),
        finalResultAPI: res.data.data
          .filter((res) => res.code > 50)
          .sort((a, b) => b.date.localeCompare(a.date)),
        circular: false,
      }),
    );
  }

  // FUNÇÃO COMPLEXA QUE FAZ A PESQUISA NA TABELA
  // PODE SER PESQUISADO POR QUAISQUER CAMPOS, SOZINHOS OU EM GRUPO

  handleFilterTable = (
    field,
    value,
    dateFromValue,
    dateToValue,
    codeValue,
    userValue,
    portaValue,
  ) => {
    const { finalResultAPI } = this.state;

    let filteredData;

    // SE TODOS OS VALORES FOREM PREENCHIDOS, FAZ A BUSCA QUE ENCAIXA EM TODOS OS CAMPOS
    if (dateFromValue && dateToValue && codeValue && userValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue &&
          el.usuario === userValue &&
          el.parametro1 === portaValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('tenho TODOS OS VALORES');

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // APENAS SE OS VALORES DE CODE, USUARIO E PORTA FOREM PREENCHIDOS
    if (codeValue && userValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) => el.code === codeValue && el.usuario === userValue && el.parametro1 === portaValue,
      );
      console.log('code, porta, usuario');

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // APENAS SE OS VALORES DO CODE E USUARIO FOREM PREENCHIDOS, FAZ A BUSCA POR ESSES DOIS CAMPOS
    if (codeValue && userValue) {
      filteredData = finalResultAPI.filter(
        (el) => el.code === codeValue && el.usuario === userValue,
      );
      console.log('code & user');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // APENAS SE OS VALORES DO CODE E PORTA FOREM PREENCHIDOS, FAZ A BUSCA POR ESSES DOIS CAMPOS
    if (codeValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) => el.code === codeValue && el.parametro1 === portaValue,
      );
      console.log('code & user');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // APENAS SE OS VALORES DO USUARIO E PORTA FOREM PREENCHIDOS, FAZ A BUSCA POR ESSES DOIS CAMPOS
    if (userValue && portaValue) {
      filteredData = finalResultAPI.filter(
        (el) => el.usuario === userValue && el.parametro1 === portaValue,
      );
      console.log('code & user');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DO CODE E DAS 2 DATAS PREENCHIDAS
    if (codeValue && dateFromValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('code & dates');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }
    // VALORES DO CODE E DATEFROM
    if (codeValue && dateFromValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z',
      );
      console.log('code & dateFrom');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DO CODE E DATETO
    if (codeValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.code === codeValue &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('code & dateTo');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DO USUARIO E DAS 2 DATAS PREENCHIDAS
    if (userValue && dateFromValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.usuario === userValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('usuario & dates');

      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }
    // VALORES DO USUARIO E DATEFROM
    if (userValue && dateFromValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.usuario === userValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z',
      );
      console.log('usuario & dateFrom');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DO USUARIO E DATETO
    if (userValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.usuario === userValue &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('usuario & dateTo');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DA PORTA E DAS 2 DATAS PREENCHIDAS
    if (portaValue && dateFromValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.parametro1 === portaValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('porta & dates');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }
    // VALORES DA PORTA E DATEFROM
    if (portaValue && dateFromValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.parametro1 === portaValue &&
          el.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z',
      );
      console.log('code & dateFrom');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // VALORES DA PORTA E DATETO
    if (portaValue && dateToValue) {
      filteredData = finalResultAPI.filter(
        (el) =>
          el.parametro1 === portaValue &&
          el.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      console.log('code & dateTo');
      return this.setState({
        lockerAPI: filteredData,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // PENÚLTIMO BLOCO
    // ESSE BLOCO IF SERVE PARA PESQUISA DE DATA
    if (field === 'dateFrom' || field === 'dateTo') {
      // COM O VALOR INICIAL A PESQUISA BUSCA DESDE A DATA DE INÍCIO ATÉ A ÚLTIMA REGISTRADA
      if (!dateToValue) {
        const filteredDataByDate = finalResultAPI.filter(
          (element) =>
            element.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z',
        );
        return this.setState({
          lockerAPI: filteredDataByDate,
          showForm: false,
          showButtonSearch: true,
        });
      }

      // COM O VALOR FINAL A PESQUISA BUSCA DESDE O PRIMEIRO REGISTRO ATÉ A DATA ESCOLHIDA
      if (!dateFromValue) {
        const filteredDataByDate = finalResultAPI.filter(
          (element) => element.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
        );
        return this.setState({
          lockerAPI: filteredDataByDate,
          showForm: false,
          showButtonSearch: true,
        });
      }

      // COM OS DOIS VALORES A PESQUISA BUSCA O INTERVALO ENTRE AS DATAS

      const filteredDataByDate = finalResultAPI.filter(
        (element) =>
          element.date >= dateFromValue.toISOString().substring(0, 11) + '00:00:00.000Z' &&
          element.date <= dateToValue.toISOString().substring(0, 11) + '23:59:59.000Z',
      );
      return this.setState({
        lockerAPI: filteredDataByDate,
        showForm: false,
        showButtonSearch: true,
      });
    }

    // FORA DO IF, SE A PESQUISA FOR APENAS POR UM CAMPO, O ÚLTIMO ESCOLHIDO PELO USUÁRIO
    // SERVE PARA TODOS OS CAMPOS EXCETO AS DATAS
    filteredData = finalResultAPI.filter((data) => data[field] === value);
    this.setState({ lockerAPI: filteredData, showForm: false, showButtonSearch: true });
  };

  // FUNÇÃO QUE ABRE O FORMS DE PESQUISA E FAZ O FILTRO PRA GERAR AS OPTIONS DO SELECT DE OPERAÇÃO
  handleSearch = () => {
    const { finalResultAPI, showForm } = this.state;

    const codeAndOperation = [];

    const map = new Map();
    for (const item of finalResultAPI) {
      if (!map.has(item.code)) {
        map.set(item.code, true);
        codeAndOperation.push({
          codigo: item.code,
          operacao: item.complemento.replace(/[0-9]/g, 'X'),
        });
      }
    }

    this.setState({
      showForm: !showForm,
      showButtonSearch: false,
      lockerAPI: finalResultAPI,
      codeAndOperation: codeAndOperation.sort((a, b) => a.codigo.localeCompare(b.codigo)),
    });
  };

  render() {
    console.log('results from API', this.state.lockerAPI);

    const dataColumn = [
      'Id',
      'Operação',
      'Porta',
      'Encomenda',
      'Usuário',
      'Gerado em',
    ];
    
    const eventoCodeComTime = (code ) =>{
        return code == "59" || code == "52" || code == "57" || code =="61"
    }
    const convertTime = ( evento ) =>{
      
      if(eventoCodeComTime(evento.code)){
        if(evento.parametro1){
          let minutes = evento.parametro1.split(":");          
          let seconds = minutes[1];
          if(seconds && seconds.length > 2){
            seconds = seconds % 60;
          } 
          
          return `${minutes[0]}:${seconds < 10 ? "0"+seconds : seconds }`
        }
        return "";
      }         
      return "";
    }
    
    const checkEvent = ( evento ) => {
      const response = (evento.code == "103" || evento.code == "104");
      if(response)
        return format( new Date(evento.date) ,"dd/MM/yy HH:mm:ss");        
      
      return format(addHours( new Date(evento.date),3 ) ,"dd/MM/yy HH:mm:ss");  //por causa da data.
      
    }
    // CMD 59 52  57 61
    // a api recebe como dados um array de objetos.
    // a tabela recebe como dados um array de arrays. Aqui eu faço um map nos dados da api e retorno
    // um array de arrays com os valores da API convertidos para elementos do array final
    const dataTable = this.state.lockerAPI.map((data) => [
      data.code,
      data.complemento,
      eventoCodeComTime(data.code) ? "": data.parametro1,
      data.encomenda,
      data.usuario,
      checkEvent(data) 
    ]);

    return this.state.circular ? (
      <Circular />
    ) : (
      <div>
        <SearchForm
          show={this.state.showForm}
          filterTable={this.handleFilterTable}
          codeAndOperation={this.state.codeAndOperation}
        />
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Button onClick={this.handleSearch} color="primary" show={this.state.showButtonSearch}>
            <Search />
            PESQUISA
          </Button>
        </div>

        <Table
          tableHead={dataColumn}
          tableData={dataTable.length > 0 ? dataTable : [['Nada encontrado']]}
          tableHeaderColor="primary"
        />
      </div>
    );
  }
}

export default withStyles(styles)(LockersOperations);
